<div class=" flex flex-row justify-between items-center align-middle p-4">
    <div class="flex flex-row gap-2">
        <h3 class="font-semibold text-lg text-blueGray-700">
            {{ selectedMonth.toDate() | moment : 'MMM YYYY' }}
        </h3>
        <div *ngIf="loading$ | async" class="animate-spin text-red-500 h-5 w-5 mr-3 ...">
        </div>
    </div>
    <div class="flex flex-row gap-4 text-sm">
        <button class="text-primary-500 px-4 py-2 rounded-md focus:outline-none" (click)="previousMonth()">
            <i class="fas fa-chevron-left mr-2"></i>Previous
        </button>
        <button class="text-primary-500 px-4 py-2 rounded-md focus:outline-none" (click)="nextMonth()">
            Next<i class="fas fa-chevron-right ml-2"></i>
        </button>
    </div>
</div>
<div>
    <div class="grid grid-cols-7 w-full justify-center">
        <div *ngFor="let item of weekdays"
            class="font-semibold text-sm text-center bg-blueGray-50 text-blueGray-500 border-blueGray-100 px-auto py-2">
            {{ item }}
        </div>
    </div>
    <div *ngFor="let week of daysByWeeks; let weekNo = index"
        class="grid grid-cols-7 w-full place-items-center content-start my-4">
        <div *ngFor="let date of week; let i = index"
            class="grid grid-cols-subgrid {{ weekNo == 0 && i == 0 ? date.day() == 1 ? 'col-span-2' : date.day() == 2 ? 'col-span-3' : date.day() == 3 ? 'col-span-4' : date.day() == 4 ? 'col-span-5' : date.day() == 5 ? 'col-span-6' : date.day() == 6 ? 'col-span-7' : date.day() == 0 ? 'col-span-1' : 'col-span-1' : 'col-span-1' }} place-items-center content-start min-h-16 h-16">
            <div
                class="{{ weekNo == 0 && i == 0 ? date.day() == 1 ? 'col-start-2' : date.day() == 2 ? 'col-start-3' : date.day() == 3 ? 'col-start-4' : date.day() == 4 ? 'col-start-5' : date.day() == 5 ? 'col-start-6' : date.day() == 6 ? 'col-start-7' : date.day() == 0 ? 'col-start-1' : 'col-start-1' : 'col-start-1' }} {{ selectedDate.format('DD-MM-yyyy') == date.format('DD-MM-yyyy') ? 'bg-primary-500 rounded-full min-h-10 h-10 w-10 text-white' : 'bg-transparent text-primary-500' }}">
                <button type="button" (click)="setSelectedDate(date, weekNo)"
                    class="{{ selectedDate.format('DD-MM-YYYY') == date.format('DD-MM-YYYY') ? 'bg-primary-500 rounded-full text-white' : 'bg-transparent text-primary-500' }} min-h-10 h-10 w-10 cursor-pointer focus:outline-none text-center align-middle">
                    {{date.date()}}
                </button>
            </div>

            <div *ngIf="events$ | async as events"
                class="flex flex-row whitespace-nowrap gap-0.5 justify-center h-4 min-h-4 p-1 w-full">
                <div *ngFor="let item of events[moment(date).format('DD-MM-YYYY')]"
                    class="h-2 w-2 rounded-full bg-primary-200 inline"></div>
            </div>
        </div>
        <div *ngIf="weekNo == selectedWeek" class="bg-blueGray-100 w-full col-span-7 p-4">
            <div *ngIf="events$ | async as events" class="flex flex-col gap-4">
                <div *ngFor="let item of events[moment(selectedDate).format('DD-MM-YYYY')]">
                    <div class="bg-white rounded-xl border border-blueGray-200/80 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden w-full cursor-pointer" [routerLink]="[item.id]">
                        <!-- Event Image (Flush top) -->
                        <div *ngIf="item.bannerImage ?? group?.imageUrl" class="h-40 w-full overflow-hidden border-b border-blueGray-100 relative">
                            <!-- Shimmer Loading Placeholder -->
                            <div *ngIf="!loadedImages.has(item.id)" class="absolute inset-0 bg-slate-200 animate-pulse z-10"></div>
                            
                            <img [src]="item.bannerImage ?? group?.imageUrl" alt="event image"
                                (load)="onImageLoad(item.id)"
                                class="object-cover w-full h-full transform hover:scale-102 transition-transform duration-300 transition-opacity duration-300"
                                [class.opacity-0]="!loadedImages.has(item.id)"
                                [class.opacity-100]="loadedImages.has(item.id)">
                        </div>
                        
                        <!-- Content Details -->
                        <div class="p-5 flex flex-col gap-3 text-left">
                            <!-- Title and Badges/Status Row -->
                            <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 w-full">
                                <h4 class="text-primary-500 text-lg font-bold truncate flex-1 min-w-0" [title]="item.name">
                                    {{item.name}}
                                </h4>
                                <div class="flex items-center gap-2 shrink-0">
                                    <!-- Public/Private Chip -->
                                    <app-chip [label]="item.isPrivate ? 'Private' : 'Public'"
                                        [prefixIcon]="item.isPrivate ? 'fas fa-lock' : 'fas fa-unlock'"
                                        [color]="item.isPrivate ? chipColor.DANGER : chipColor.SECONDARY"
                                        padding="px-2.5 py-1"
                                        fontSize="text-[11px] font-medium">
                                    </app-chip>
                                    
                                    <!-- Status Chip -->
                                    <app-btn-event-status [status]="item.status"
                                        [isDisabled]="true"></app-btn-event-status>

                                    <!-- <div *ngIf="isAdmin" class="flex flex-row flex-nowrap gap-4 ml-2">
                                        <button type="button" (click)="duplicate(item)" [disabled]="!isAdmin"
                                            routerLinkActive="router-link-active">
                                            <i class="text-secondary-500 text-xl fa-regular fa-copy"></i>
                                        </button>
                                        <button type="button" [routerLink]="[item.id,'edit']"
                                            routerLinkActive="router-link-active" [disabled]="!isAdmin">
                                            <i class="text-secondary-500 text-xl fa fa-edit"></i>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            
                            <!-- Event Time and Details -->
                            <div class="flex flex-col gap-2">
                                <!-- Time Badge/Row -->
                                <div class="flex items-center gap-2 text-blueGray-500 text-xs font-semibold">
                                    <i class="far fa-clock text-primary-400"></i>
                                    <span>
                                        {{item.startDateTime.toDate() | moment : 'hh:mm a'}} - {{item.endDateTime.toDate() | moment : 'hh:mm a'}}
                                    </span>
                                </div>
                                
                                <!-- Description -->
                                <p class="text-blueGray-600 text-sm whitespace-pre-line leading-relaxed mt-1 line-clamp-3">
                                    {{item.description}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>